import React from 'react';

import { RadioOptionsWithConfirm, IQuestion, InputWithConfirm, CurrencyInputWithConfirm } from 'shared-components';

import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { useDispatch } from 'react-redux';

import { savePreCasInterview } from '../../../../store/student/actions';
import { createUpdatePCIFieldAction } from '../../../../store/student/preCasInterview/actions';
import { Pages } from '../../../../store/student/preCasInterview/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

export interface IProps {
  complete: boolean;
  currentStep: number;
  steps: number;
  liveWhileStudying: string;
  liveWhileStudyingOther: string;
  expectedWeeklyRent?: number;
  commutePlan: string;
  expectedLivingExpenses?: number;
  awareOfUKVIInterview?: boolean;
}

type Props = IProps;

const InterviewQPage4 = (props: Props) => {
  // TODO: check why we have this and remove it if not needed
  const liveWhileStudyingError = '';
  const liveWhileStudyingOtherError = '';
  const expectedWeeklyRentError = '';
  const commutePlanError = '';
  const expectedLivingExpensesError = '';
  const awareOfUKVIInterviewError = '';

  const {
    liveWhileStudying,
    liveWhileStudyingOther,
    expectedWeeklyRent,
    commutePlan,
    expectedLivingExpenses,
    awareOfUKVIInterview,

    complete,
    currentStep,
    steps,
  } = props;

  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(savePreCasInterview(Pages.PAGE4));
  };
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdatePCIFieldAction(fieldName, value, refValue));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Pre-CAS Questionnaire'}
    >
      <RadioOptionsWithConfirm
        label="Where do you plan to live while studying?"
        errorText={liveWhileStudyingError}
        questions={[
          {
            char: '1',
            label: 'On-campus accommodation',
            selected: liveWhileStudying === 'On-campus accommodation',
          },
          {
            char: '2',
            label: 'Private accommodation',
            selected: liveWhileStudying === 'Private accommodation',
          },
          {
            char: '3',
            label: 'With friends or family in the UK',
            selected: liveWhileStudying === 'With friends or family in the UK',
          },
          {
            char: '4',
            label: 'I have not decided yet',
            selected: liveWhileStudying === 'I have not decided yet',
          },
          {
            char: '5',
            label: 'Other',
            selected: liveWhileStudying === 'Other',
          },
        ]}
        onClick={(question: IQuestion) => onChange(Q.LIVE_WHILE_STUDYING, question.label)}
      />

      {liveWhileStudying === 'Other' && (
        <InputWithConfirm
          key={Q.MAX_WORK_HOURS_PER_WEEK}
          value={liveWhileStudyingOther}
          errorText={liveWhileStudyingOtherError}
          label={'Please provide more information'}
          onChange={(event: React.FormEvent<HTMLInputElement>) =>
            onChange(Q.LIVE_WHILE_STUDYING_OTHER, event.currentTarget.value)
          }
        />
      )}

      <CurrencyInputWithConfirm
        id="expectedSalary"
        value={expectedWeeklyRent}
        errorText={expectedWeeklyRentError}
        onChange={(event: React.FormEvent<HTMLInputElement>) => {
          const value = Number(event.currentTarget.value) || 0;
          onChange(Q.EXPECTED_WEEKLY_RENT, value);
        }}
        label="How much do you expect to pay for accommodation per week?"
      />

      <RadioOptionsWithConfirm
        label="How will you travel between your accommodation and the university campus?"
        errorText={commutePlanError}
        questions={[
          {
            char: '1',
            label: 'Walk',
            selected: commutePlan === 'Walk',
          },
          {
            char: '2',
            label: 'Bicycle',
            selected: commutePlan === 'Bicycle',
          },
          {
            char: '3',
            label: 'Public transport e.g. bus or train',
            selected: commutePlan === 'Public transport e.g. bus or train',
          },
          {
            char: '4',
            label: 'Drive e.g. taxi, my own car',
            selected: commutePlan === 'Drive e.g. taxi, my own car',
          },
          {
            char: '5',
            label: 'I am not sure',
            selected: commutePlan === 'I am not sure',
          },
        ]}
        onClick={(question: IQuestion) => onChange(Q.COMMUTE_PLAN, question.label)}
      />

      <CurrencyInputWithConfirm
        id="expectedSalary"
        value={expectedLivingExpenses}
        errorText={expectedLivingExpensesError}
        onChange={(event: React.FormEvent<HTMLInputElement>) => {
          const value = Number(event.currentTarget.value) || 0;
          onChange(Q.EXPECTED_LIVING_EXPENSES, value);
        }}
        label="How much do you expect to spend in living expenses per week? (e.g an amount to cover food, daily travel, school expenses, phone, socialising etc.)"
      />

      <RadioOptionsWithConfirm
        label="International students can be interviewed by UKVI prior to receiving a visa, were you aware of this?"
        errorText={awareOfUKVIInterviewError}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: awareOfUKVIInterview === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: awareOfUKVIInterview === false,
          },
        ]}
        isInline={true}
        onClick={(question: IQuestion) => onChange(Q.AWARE_OF_UK_VI_INTERVIEW, question.label === 'Yes')}
      />
    </QuestionPage>
  );
};

export default InterviewQPage4;
